import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HostOverlay from './HostOverlay';
import { selectGameId } from 'features/gamestate/gameStateSlice';
import { watchPlayersAction } from 'features/player/playerSlice';
import logging from 'utils/logging';

const log = logging.getLogger('GameBoardHostOverlay');
log.setLevel('debug');

/**
 * GameBoard-specific wrapper for the host overlay
 * This ensures players are being watched and narrations work correctly
 * Only used in the GameBoardState component
 */
const GameBoardHostOverlay = (props) => {
  const dispatch = useDispatch();
  const gameId = useSelector(selectGameId);
  
  // Ensure we're watching players when the gameboard loads
  useEffect(() => {
    if (gameId) {
      log.debug(`Ensuring players are being watched for game ${gameId}`);
      dispatch(watchPlayersAction(gameId));
    }
  }, [gameId, dispatch]);
  
  return (
    <>
        {props.children}
        <HostOverlay />
    </>
  );
};

export default GameBoardHostOverlay; 